import { SessionRecorder } from 'client/utils/session-recorder/session-recorder';

export function recordError() {
  SessionRecorder.addTag('SystemError');
}
